import Vue from 'vue'
import { cloneDeep } from 'lodash'
import { showAncestors } from '@modules/filters'
const state = {
  personal: {
    title: '',
    lastname: '',
    firstname: '',
    middlename: '',
    picture: '',
    company: '',
    department: '',
    job: '',
    phone: '',
    fax: '',
    mobilePhone: '',
    email: '',
    facebook: '',
    twitter: '',
    linkedin: '',
    password: '',
    passwordConfirmation: '',
    mailing: {
      streetname: '',
      number: '',
      box: '',
      zip: '',
      city: '',
      country: 'none'
    },
    street: {
      sameAddress: false,
      streetname: '',
      number: '',
      box: '',
      zip: '',
      city: '',
      country: ''
    },
    assistant: {
      name: '',
      email: '',
      phone: '',
      fax: ''
    },
    dietary: ''
  },
  subscriptions: {
    frequency: '',
    croplifeEvents: false,
    externalEvents: false,
    pesticide: false,
    selected: [],
    documents: {
      categories: []
    },
    icons: {
      company: 'briefcase',
      groupsTeams: 'workgroups',
      workArea: 'target',
      roleType: 'pencil',
      meetingType: 'calendar',
      document: 'briefcase',
      topics: 'topics',
      subtopics: 'subtopics',
      myDocument: 'user',
      date: 'user'
    }

  }
}

const getters = {
  getIcons: state => state.subscriptions.icons,
  getSelected: state => state.subscriptions.selected,
  getCategories: state => state.subscriptions.documents.categories
}

const mutations = {
  UPDATE_SELECTED: (state, array) => {
    state.subscriptions.selected = [ ...array ]
  },
  UPDATE_CATEGORIES: (state, array) => {
    state.subscriptions.documents.categories = [ ...array ]
  },
  UPDATE_ITEM_ACTIVE: (state, { categoryIndex, guid, active }) => {
    const items = state.subscriptions.documents.categories[categoryIndex].items
    const index = items.findIndex(item => item.guid === guid)
    if (index > -1) {
      const item = items[index]
      if (item.parent === '') {
        items.forEach(item => {
          if (item.parent === guid) Vue.set(item, 'active', active)
        })
      }
      Vue.set(item, 'active', active)
    } else {
      console.error(`UPDATE_ITEM_ACTIVE : Index not found || ${guid}`)
    }
  },
  UPDATE_ITEM_SHOW: (state, { categoryIndex, guid, status }) => {
    const items = state.subscriptions.documents.categories[categoryIndex].items
    const index = items.findIndex(item => item.guid === guid)
    if (index > -1) {
      Vue.set(items[index], 'show', status)
    } else {
      console.error(`UPDATE_ITEM_SHOW : Index not found || ${guid}`)
    }
  },
  updatePersonal: (state, personal) => {
    state.personal = Object.assign({ ...state.personal }, { ...personal })
  },
  updateSubscriptions: (state, subscriptions) => {
    state.subscriptions = Object.assign({ ...state.subscriptions }, { ...subscriptions })
  },
  updatePersonalField: (state, { key, value }) => {
    Vue.set(state.personal, key, value)
  },
  updateSubscriptionsField: (state, { key, value }) => {
    Vue.set(state.subscriptions, key, value)
  },
  updatePersonalNestedField: (state, { key, nestedKey, value }) => {
    Vue.set(state.personal[key], nestedKey, value)
  },
  updateStreetAddress: (state) => {
    const street = state.personal['street']
    const mailing = state.personal['mailing']
    const sameAddress = street.sameAddress

    Vue.set(street, 'streetname', sameAddress ? mailing.streetname : '')
    Vue.set(street, 'number', sameAddress ? mailing.number : '')
    Vue.set(street, 'box', sameAddress ? mailing.box : '')
    Vue.set(street, 'zip', sameAddress ? mailing.zip : '')
    Vue.set(street, 'city', sameAddress ? mailing.city : '')
    Vue.set(street, 'country', sameAddress ? mailing.country : 'none')
  }
}

const actions = {
  updateCategories: ({ commit, dispatch }, categories) => {
    commit('UPDATE_CATEGORIES', categories)
    dispatch('updateSelected')
  },
  updateItemActive: ({ commit }, { categoryIndex, guid, active }) => {
    commit('UPDATE_ITEM_ACTIVE', { categoryIndex, guid, active })
  },
  updateFilterItemShow: ({ commit }, { categoryIndex, guid, status }) => {
    commit('UPDATE_ITEM_SHOW', { categoryIndex, guid, status })
  },
  updateAllItemsActive: ({ dispatch, state }, { categoryIndex, active }) => {
    state.subscriptions.documents.categories[categoryIndex].items.forEach(item => {
      dispatch('updateItemActive', {
        categoryIndex,
        guid: item.guid,
        active: active
      })
    })
  },
  updateAllItemsShow: ({ dispatch, state }, { categoryIndex, query }) => {
    const items = state.subscriptions.documents.categories[categoryIndex].items
    items.forEach(item => {
      const status = item.label.toLowerCase().includes(query.toLowerCase())
      dispatch('updateItemShow', { categoryIndex, guid: item.guid, status })
      if (status) showAncestors({ dispatch, categoryIndex, items, item })
    })
  },
  updateSelected: ({ commit, state }) => {
    const selected = []
    const categories = cloneDeep(state.subscriptions.documents.categories)
    categories.forEach(category => {
      const items = cloneDeep(category.items)
      const returnedCategory = {
        guid: category.guid,
        items: []
      }
      items.forEach(item => {
        if (item.active) returnedCategory.items.push(item)
      })
      selected.push(returnedCategory)
    })
    commit('UPDATE_SELECTED', selected)
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
